export interface UpdateSystemUserRequest {
  id: number
  passwordExpirationDate: string
  name: string
  isActive: boolean
  groupId: number
  authFailureLimitCount: number
  note: string
  revision: number
}

export function UpdateSystemUserRequestToJSON(
  value: UpdateSystemUserRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    password_expiration_date:
      value.passwordExpirationDate !== ''
        ? value.passwordExpirationDate
        : undefined,
    name: value.name !== '' ? value.name : undefined,
    is_active: value.isActive ?? undefined,
    group_id: value.groupId !== 0 ? value.groupId : undefined,
    auth_failure_limit_count:
      value.authFailureLimitCount !== 0
        ? value.authFailureLimitCount
        : undefined,
    note: value.note !== '' ? value.note : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
